<template>
	<div>
		<div class="servicePersonnel">
			<div class="tips">
				为更好的为您提供服务，服务过程中有任何疑问，请及时与以下人员联系，我们将竭诚为您服务！
			</div>
			<div class="personnel_list">
				<div class="personnel_list_item" v-for="(item, index) in personnelInfo" :key="index">
					<el-avatar fit="contain" shape="square" :size="60" :src="item.avatar"></el-avatar>
					<div class="personnel_info">
						<div class="info_name">{{ `${item.username}（${item.englishname}）` }}</div>
						<div class="info_Position">{{ item.position	 }}</div>
					</div>
					<el-popover
						placement="top"
						popper-class="confirmSchemeInfo_popover"
						width="350"
						trigger="hover"
					>
					<i class="el-icon-more" slot="reference"> </i>
						<div class="info_popover">
							<div class="info_body">
								<div class="info_name">{{ `${item.username}（${item.englishname}）` }}</div>
								<div class="info_company">上海天擎天拓信息技术股份有限公司</div>
								<div class="info_num">工号：{{ item.number }}</div>
								<div class="info_num">手机：{{ item.phone }}</div>
								<div class="info_num">邮箱：{{ item.email }}</div>
							</div>
							<div class="code_body">
								<el-avatar
									fit="contain"
									shape="square"
									:size="60"
									:src="item.qrCode"
								></el-avatar>
							</div>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['personnelInfo'],
	data() {
		return {};
	},

	components: {},

	computed: {},

	methods: {},
};
</script>

<style lang="scss" scoped>
.servicePersonnel {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 20px 0 0;

	.tips {
		font-size: 15px;
		font-weight: 600;
		color: #333333;
		margin-bottom: 20px;
		// align-self: flex-start;
	}

	.personnel_list {
		display: flex;

		.personnel_list_item {
			display: flex;
			align-items: center;
			margin: 10px 50px;
			padding: 10px 15px;
			background: #fff;

			.personnel_info {
				margin: 0 20px;

				.info_name {
					font-weight: 600;
					font-size: 16px;
				}

				.info_Position {
					margin-top: 5px;
					color: #cdcdcd;
				}
			}

			.iconfont {
				font-size: 20px;
				color: #5da2ff;
				cursor: pointer;
			}
		}
	}
}
</style>
<style lang="scss">
.confirmSchemeInfo_popover {
	.info_popover {
		display: flex;
		align-items: center;

		.info_body {
			display: flex;
			flex-direction: column;

			div {
				margin: 2px 0px;
			}

			.info_name {
				font-size: 16px;
				font-weight: 600;
				color: #333333;
			}

			.info_company {
				font-size: 14px;
				font-weight: 400;
				color: #333333;
			}

			.info_num {
				font-size: 14px;
				font-weight: 400;
				color: #666666;
			}
		}

		.code_body {
			margin-left: 30px;
		}
	}
}
</style>
